export default __webpack_public_path__ + "static/media/clear-sans-all-700-normal.92762598.woff";